module.exports = __webpack_public_path__ + "img/20.858142cd.png";